import React, {useEffect, useState} from "react";
import {FullScreenCloseIcon, FullScreenIcon} from "../Icons";

export default ({onClick, active}) => {
    // const [active, setActive] = useState(false);

    // useEffect(() => {
    //     const listener = () => setActive(!!document.fullscreenElement);

    //     document.addEventListener('fullscreenchange', listener);

    //     return () => {
    //         document.removeEventListener('fullscreenchange', listener);
    //     }
    // }, []);

    return <a onClick={onClick}>{active ? <FullScreenCloseIcon /> : <FullScreenIcon />}</a>
}
